export const formatPlateForDisplay = (plate: string): string => {
  if (!plate) return '';
  
  // Tüm boşlukları kaldır ve büyük harfe çevir
  const cleanPlate = plate.replace(/\s+/g, '').toUpperCase();
  
  // İlk 2 karakter (il kodu)
  const ilKodu = cleanPlate.slice(0, 2);
  
  // Harf kısmı (1-3 harf)
  const harfMatch = cleanPlate.slice(2).match(/[A-Z]+/);
  const harfKismi = harfMatch ? harfMatch[0] : '';
  
  // Sayı kısmı (son kısım)
  const sayiKismi = cleanPlate.slice(2 + harfKismi.length);
  
  // Formatlanmış plaka
  return `${ilKodu} ${harfKismi} ${sayiKismi}`.trim();
};

export const validatePlate = (plate: string): boolean => {
  // Boşlukları kaldır ve büyük harfe çevir
  const cleanPlate = plate.replace(/\s+/g, '').toUpperCase();
  
  // Türkiye plaka formatı regex
  // 2 rakam + 1-3 harf + 2-4 rakam
  const plateRegex = /^[0-9]{2}[A-Z]{1,3}[0-9]{2,4}$/;
  
  return plateRegex.test(cleanPlate);
};

export const formatPlateForInput = (plate: string): string => {
  // Sadece rakam ve harfleri al, boşlukları kaldır ve büyük harfe çevir
  return plate.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}; 